<template>
  <v-fade-transition leave-absolute>
    <div class="d-flex flex-column" v-if="!parentLoading" style="gap: 8px">
      <div
        class="d-flex align-center justify-space-between flex-wrap"
        style="gap: 24px; min-height: 44px"
      >
        <div
          v-if="title || subtitle"
          class="d-flex flex-column align-start justify-center"
        >
          <div class="d-flex align-center justify-start" style="gap: 8px">
            <v-icon>mdi-clipboard-list</v-icon>
            <div
              v-if="title"
              class="text-body-1 font-weight-black primary--text d-flex grow"
            >
              {{ title }}
            </div>
          </div>
          <!-- <div v-if="subtitle" class="text-body-2 text--secondary d-flex grow">
            {{ subtitle }}
          </div> -->
        </div>
        <div
          class="d-flex align-center justify-end justify-self-end shrink"
          style="gap: 12px"
        >
          <v-menu
            v-if="!mobileSearch"
            offset-y
            :nudge-bottom="8"
            content-class="rounded-lg"
            key="filter"
          >
            <template v-slot:activator="{ on, attrs, value }">
              <v-chip
                v-bind="attrs"
                v-on="$vuetify.breakpoint.smAndDown ? on : ''"
                @click="
                  $vuetify.breakpoint.smAndDown
                    ? ''
                    : (showFilters = !showFilters)
                "
                :class="{ 'v-chip--active': !!currentTab }"
                text-color="review"
                :outlined="!!currentTab"
                class="rounded-pill text-caption text-lg-body-2 grow d-flex align-center justify-center font-weight-bold"
                style="
                  gap: 6px;
                  padding-right: 10px;
                  min-height: 28px !important;
                "
                :style="filterBackgroundColor"
                v-if="!mobileSearch"
              >
                <div
                  class="d-flex align-center justify-center"
                  style="gap: 6px"
                >
                  <v-icon :size="16" color="review">
                    mdi-filter-variant
                  </v-icon>
                  <v-fade-transition
                    leave-absolute
                    hide-on-leave
                    group
                    :duration="150"
                    tag="div"
                    class="d-flex align-center justify-center"
                    style="gap: 4px"
                  >
                    <span v-if="!!currentTab" key="value">1</span>
                    <span key="label">Filter</span>
                    <v-icon
                      v-if="currentTab"
                      small
                      color="review"
                      key="closeBtn"
                      class="ml-1"
                      @click.stop="currentTab = null"
                      >mdi-close-circle</v-icon
                    >
                    <v-icon
                      v-if="!currentTab"
                      size="20"
                      color="review"
                      key="menuIcon"
                    >
                      {{
                        showFilters || value ? "mdi-menu-up" : "mdi-menu-down"
                      }}
                    </v-icon>
                  </v-fade-transition>
                </div>
              </v-chip>
            </template>
            <v-list dense content-class="rounded-lg" class="pt-0">
              <v-subheader
                class="font-weight-bold justify-center"
                style="height: 30px"
                >Status</v-subheader
              >
              <v-list-item-group v-model="currentTab">
                <v-list-item
                  v-for="(item, index) in orderStatuses"
                  :key="index"
                  :value="item.value"
                  :dense="$vuetify.breakpoint.smAndDown"
                  :style="{
                    minHeight: $vuetify.breakpoint.smAndDown ? '35px' : '40px',
                  }"
                >
                  <v-list-item-title class="d-flex align-center">{{
                    item.text
                  }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-fade-transition
            tag="div"
            class="d-flex align-center justify-end shrink"
            style="gap: 12px; transition: all 0.15s ease !important"
            leave-absolute
            hide-on-leave
            group
          >
            <v-text-field
              v-if="
                $vuetify.breakpoint.lgAndUp || mobileSearch || search?.length
              "
              label="Search"
              outlined
              dense
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              hide-details
              clearable
              style="width: clamp(75px, 80%, 90%)"
              @focus="handleSearchOpen"
              @blur="handleSearchClose"
              id="search"
              key="search"
            ></v-text-field>
            <StyledButton
              v-if="
                !mobileSearch && $vuetify.breakpoint.mdAndDown && !search.length
              "
              :action="handleSearchClick"
              preset="outlined-stacked"
              icon="mdi-magnify"
              :dense="true"
              label="Search"
              key="searchButton"
              rounded="rounded"
              size="large"
            />
            <StyledButton
              v-if="!mobileSearch && !search.length"
              :action="() => traverse('export')"
              preset="outlined-stacked"
              icon="mdi-file-export-outline"
              :dense="true"
              label="Export"
              key="exportButton"
              rounded="rounded"
              size="large"
              v-show="enableExport && orders?.length"
            />
            <StyledButton
              v-if="!mobileSearch && !search.length"
              :action="handleExpandClick"
              preset="outlined-stacked"
              icon="mdi-arrow-expand"
              :dense="true"
              label="Expand"
              key="expandButton"
              rounded="rounded"
              size="large"
            />
          </v-fade-transition>
        </div>
      </div>
      <v-expand-transition>
        <div
          v-if="showFilters"
          class="d-flex justify-space-around align-start pa-2 rounded"
          style="gap: 24px"
          :style="{
            border: `1px dotted ${$vuetify.theme.currentTheme.background3}`,
          }"
        >
          <span
            class="rounded-pill ps-2 pt-2 review--text text-caption d-flex align-center justify-center text-lg-body-2 font-weight-bold"
            style="height: 28px; gap: 6px"
          >
            <v-icon small color="review"> mdi-list-status </v-icon>
            <span>Status</span>
          </span>
          <div
            class="d-flex overflow-auto"
            :style="{ width: '100%', whiteSpace: 'nowrap' }"
          >
            <v-chip-group
              v-model="currentTab"
              active-class="review--text font-weight-black"
              class="text-caption font-weight-medium"
              :dark="$vuetify.theme.isDark"
              :light="!$vuetify.theme.isDark"
              :mobile-breakpoint="$vuetify.breakpoint.mobileBreakpoint"
              show-arrows
            >
              <v-chip
                v-for="status in orderStatuses"
                small
                :key="status.value"
                :outlined="currentTab === status.value"
                :value="status.value"
                :style="filterBackgroundColor"
              >
                {{ status.text }}
              </v-chip>
            </v-chip-group>
          </div>
        </div>
      </v-expand-transition>
      <v-data-table
        :headers="headers"
        :items="orders"
        :dense="dense"
        :loading="parentLoading || loading"
        :items-per-page.sync="itemsPerPage"
        :search="effectiveSearch"
        :custom-filter="customSearch"
        :custom-sort="customSort"
        :key="searchTrigger"
        no-results-text="No results found"
        loading-text="Loading..."
        sort-by="date"
        sort-desc
        mobile-breakpoint="0"
        :page.sync="currentPage"
        fixed-header
        height="100%"
        class="d-flex flex-grow-1 flex-column"
        style="overflow: auto; max-height: 50vh"
        hide-default-footer
      >
        <template v-slot:item.number="{ item, index }">
          <span class="text-caption text-lg-body-2">
            {{ ((currentPage - 1) * itemsPerPage + index + 1) | addComma }}
          </span>
        </template>
        <template v-slot:item.date="{ item }">
          <div class="d-flex flex-column">
            <div
              class="d-flex justify-start align-center text-truncate"
              style="gap: 6px; width: 100%; max-width: 100%"
            >
              <v-icon xSmall>mdi-calendar</v-icon>
              <span class="text-caption text-lg-body-2">{{
                formatDate(item)
              }}</span>
            </div>
            <div
              class="d-flex justify-start align-center text-truncate"
              style="gap: 6px; width: 100%; max-width: 100%"
            >
              <v-icon xSmall>mdi-account</v-icon>
              <span
                class="text-caption text-capitalize text--secondary"
                :style="{
                  fontSize: $vuetify.breakpoint.smAndDown
                    ? '10px !important'
                    : '',
                }"
                >{{ item.createdBy }}</span
              >
            </div>
          </div>
        </template>
        <template v-slot:item.orderNumber="{ item }">
          <div class="d-flex align-center" style="gap: 8px">
            <!-- Order numbers column -->
            <div class="d-flex flex-column">
              <router-link
                v-if="item.internal"
                :to="{ name: 'salesOrder-view', params: { id: item.id } }"
                target="_blank"
                class="review--text"
              >
                <span
                  class="text-uppercase text-caption text-lg-body-2 text-no-wrap"
                  :class="
                    $vuetify.breakpoint.smAndDown
                      ? 'font-weight-bold'
                      : 'font-weight-medium'
                  "
                >
                  {{ item.internal }}
                </span>
              </router-link>
              <span v-else class="text-caption text-lg-body-2 text--disabled">-</span>
              
              <span
                v-if="item.external"
                class="text-uppercase text-caption text-no-wrap text--secondary"
                :style="{
                  fontSize: $vuetify.breakpoint.smAndDown
                    ? '10px !important'
                    : '',
                }"
              >
                {{ item.external }}
              </span>
            </div>
            
            <!-- Sample icon aligned center vertically -->
            <v-tooltip top v-if="item.sample">
              <template v-slot:activator="{ on, attrs }">
                <v-icon 
                  :color="$vuetify.theme.currentTheme.review" 
                  v-bind="attrs" 
                  v-on="on"
                  style="align-self: center;"
                >mdi-alpha-s-circle
                </v-icon>
              </template>
              <span>{{
                item.samplePurpose === 'buyerSamples' ? 'Buyer Sample' :
                item.samplePurpose === 'eventSamples' ? 'Event Sample' :
                item.samplePurpose === 'staffSamples' ? 'Staff Sample' :
                'Sample Order'
              }}</span>
            </v-tooltip>
          </div>
        </template>
        <!-- <template v-slot:item.orderNumber="{ item }">
          <div class="d-flex flex-column">
            <router-link
              v-if="item.internal"
              :to="{ name: 'salesOrder-view', params: { id: item.id } }"
              target="_blank"
              class="review--text"
            >
              <span
                class="text-uppercase text-caption text-lg-body-2 text-no-wrap"
                :class="
                  $vuetify.breakpoint.smAndDown
                    ? 'font-weight-bold'
                    : 'font-weight-medium'
                "
                >{{ item.internal }}</span
              >
            </router-link>
            <span v-else class="text-caption text-lg-body-2 text--disabled"
              >-</span
            >
            <span
              v-if="item.external"
              class="text-uppercase text-caption text-no-wrap text--secondary"
              :style="{
                fontSize: $vuetify.breakpoint.smAndDown
                  ? '10px !important'
                  : '',
              }"
              >{{ item.external }}
            </span>
          </div>
        </template> -->
        <template v-slot:item.status="{ item }">
          <span
            class="font-weight-bold text-center text-caption text-lg-body-2 text-no-wrap rounded-pill"
            :style="{
              background: `${
                ['error', 'products'].includes(item.statusColor)
                  ? $vuetify.theme.currentTheme[item.statusColor]
                  : item.statusColor
              }33`,
              color: `${
                ['error', 'products'].includes(item.statusColor)
                  ? $vuetify.theme.currentTheme[item.statusColor]
                  : item.statusColor
              }`,
              padding: $vuetify.breakpoint.smAndDown ? '3px 10px' : '5px 12px',
            }"
            style="min-width: 67px"
          >
            {{ item.status.text }}
          </span>
        </template>
        <template v-slot:item.balance="{ item }">
          <span
            v-if="item.status.value !== 'draftOrder'"
            class="text-caption text-lg-body-2"
            >{{ item.balance | currency }}</span
          >
          <span v-else class="text-caption text-lg-body-2 text--disabled"
            >-</span
          >
        </template>
        <template v-slot:item.total="{ item }">
          <span class="text-caption text-lg-body-2">{{
            item.total | currency
          }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-center" style="gap: 8px">
            <DelayedTooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  outlined
                  text
                  icon
                  v-bind="attrs"
                  :loading="item.loadingPreview"
                  v-on="on"
                  color="review"
                  class="rounded"
                  @click="$emit('preview', item)"
                  style="min-width: 21px"
                >
                  <v-icon small>mdi-text-box-search</v-icon>
                </v-btn>
              </template>
              Preview
            </DelayedTooltip>
            <router-link
              v-if="item.status.value !== 'draftOrder'"
              @click.stop
              :to="{ name: 'salesOrder-view', params: { id: item.id } }"
            >
              <DelayedTooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    text
                    icon
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    color="review"
                    class="rounded"
                    style="min-width: 21px"
                  >
                    <v-icon small>mdi-eye</v-icon>
                  </v-btn>
                </template>
                View
              </DelayedTooltip>
            </router-link>
          </div>
        </template>
        <template v-slot:footer="{ props, on, headers, widths }">
          <v-divider class="d-block"></v-divider>
          <div class="mt-3 d-flex justify-space-between align-center">
            <div
              v-if="deviceSize.tablet"
              class="d-flex justify-start align-center ml-2 flex-wrap"
              style="column-gap: 12px"
            >
              <span
                class="rounded-pill review--text text-caption d-flex align-center justify-center text-lg-body-2 font-weight-bold"
                style="height: 28px; gap: 6px"
              >
                <v-icon small color="review"> mdi-table-row-height </v-icon>
                <span>Rows:</span>
              </span>
              <v-chip-group
                v-model="itemsPerPage"
                active-class="review--text font-weight-black"
                class="text-caption font-weight-bold"
                mandatory
              >
                <v-chip
                  v-for="size in [5, 10, 15, 'All']"
                  small
                  :key="size"
                  :outlined="
                    itemsPerPage === size ||
                    (itemsPerPage === -1 && size === 'All')
                  "
                  :style="filterBackgroundColor"
                  :value="typeof size === 'number' ? size : -1"
                >
                  {{ size }}
                </v-chip>
              </v-chip-group>
            </div>
            <v-menu
              v-else
              offset-y
              :nudge-bottom="8"
              content-class="rounded-lg"
            >
              <template v-slot:activator="{ on, attrs, value }">
                <v-chip
                  :style="filterBackgroundColor"
                  v-bind="attrs"
                  v-on="on"
                  close-icon="mdi-trash-can"
                  text-color="review"
                  class="rounded-pill text-caption text-lg-body-2 font-weight-bold"
                  style="padding-right: 10px"
                  @click:close="currentTab = null"
                >
                  <div
                    class="d-flex align-center justify-center"
                    style="height: 28px; gap: 6px"
                  >
                    <v-icon small color="review"> mdi-table-row-height </v-icon>
                    <div class="d-flex align-center justify-center">
                      <span class="mr-1"
                        >Rows:
                        <span class="font-weight-black">{{
                          itemsPerPage === -1 ? "All" : itemsPerPage
                        }}</span></span
                      >
                      <v-icon
                        size="20"
                        color="review"
                        :class="{ rotate: value }"
                      >
                        mdi-menu-down
                      </v-icon>
                    </div>
                  </div>
                </v-chip>
              </template>
              <v-list dense content-class="rounded-lg">
                <v-list-item
                  v-for="(item, index) in [5, 10, 15, 'All']"
                  :key="index"
                  @click="itemsPerPage = item === 'All' ? -1 : item"
                  :dense="$vuetify.breakpoint.smAndDown"
                  :style="{
                    minHeight: $vuetify.breakpoint.smAndDown ? '35px' : '40px',
                  }"
                >
                  <v-list-item-title
                    class="d-flex align-center"
                    :style="{
                      minHeight: $vuetify.breakpoint.smAndDown
                        ? '35px'
                        : '40px',
                    }"
                    >{{ item }}</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
            <div class="d-flex align-center" style="gap: 20px">
              <span class="text-caption font-weight-medium text-end">{{
                `${$options.filters.addComma(
                  props.pagination.page * itemsPerPage - itemsPerPage + 1
                )}-${$options.filters.addComma(
                  itemsPerPage === -1
                    ? props.pagination.itemsLength
                    : Math.min(
                        props.pagination.itemsLength,
                        props.pagination.page * itemsPerPage
                      )
                )} of ${$options.filters.addComma(
                  props.pagination.itemsLength
                )}`
              }}</span>
              <div class="d-flex align-center" style="gap: 8px">
                <v-btn
                  class="text-caption font-weight-bold"
                  :min-height="$vuetify.breakpoint.smAndDown ? '30px' : '40px'"
                  outlined
                  small
                  depressed
                  text
                  color="review"
                  style="text-transform: none !important"
                  @click="props.options.page--"
                  :disabled="props.options.page - 1 === 0"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn
                  class="text-caption font-weight-bold"
                  :min-height="$vuetify.breakpoint.smAndDown ? '30px' : '40px'"
                  outlined
                  small
                  depressed
                  text
                  color="review"
                  style="text-transform: none !important"
                  @click="props.options.page++"
                  :disabled="
                    props.options.page + 1 > props.pagination.pageCount
                  "
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </template>
      </v-data-table>
      <!-- Export -->
      <v-dialog
        scrollable
        persistent
        transition="scale-transition"
        v-model="dialog.export"
      >
        <v-card>
          <v-card-title
            class="justify-center"
            :style="`background: ${$vuetify.theme.currentTheme.primary}; color: ${$vuetify.theme.currentTheme.secondary};`"
          >
            <span class="text-uppercase">orders | export</span>
          </v-card-title>
          <v-card-text v-if="payload.export" class="my-3">
            <!-- Current View -->
            <v-alert :color="$vuetify.theme.currentTheme.ledger" dark>
              <v-icon large class="mr-2">mdi-clipboard-list</v-icon>
              <span class="text-capitalize">
                {{ exportAccountName ? `${exportAccountName} - ` : "" }}sales,
                orders
              </span>
            </v-alert>
            <!-- Export Options -->
            <v-card flat outlined class="rounded-lg mb-3">
              <v-card-title
                :style="`background: ${$vuetify.theme.currentTheme.primary}; color: ${$vuetify.theme.currentTheme.secondary};`"
              >
                <v-icon
                  large
                  class="mr-1"
                  :color="$vuetify.theme.currentTheme.secondary"
                  >{{ $vuetify.icons.values.settings }}</v-icon
                >
                <span class="text-uppercase">export options</span>
              </v-card-title>
              <v-card-text class="pb-2">
                <v-row>
                  <v-col cols="12">
                    <span class="subtitle-2 text--secondary mb-2 d-block"
                      >Choose what to include in your export:</span
                    >
                    <v-checkbox
                      v-model="payload.exportOptions.includeLineItems"
                      :color="$vuetify.theme.currentTheme.primary"
                      label="Line Items (detailed view with individual product lines)"
                      class="mt-0"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="payload.exportOptions.includeOrders"
                      :color="$vuetify.theme.currentTheme.primary"
                      label="Orders Summary (order-level overview)"
                      class="mt-0"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-alert
                  v-if="
                    !payload.exportOptions.includeLineItems &&
                    !payload.exportOptions.includeOrders
                  "
                  :color="$vuetify.theme.currentTheme.warning"
                  text
                  dense
                  class="mt-2"
                >
                  <span>Please select at least one export option</span>
                </v-alert>
                <v-alert
                  v-if="
                    payload.exportOptions.includeLineItems &&
                    payload.exportOptions.includeOrders
                  "
                  :color="$vuetify.theme.currentTheme.success"
                  text
                  dense
                  class="mt-2"
                >
                  <span>Both tabs will be included in your Excel file</span>
                </v-alert>
              </v-card-text>
            </v-card>
            <!-- Orders -->
            <v-card flat outlined class="rounded-lg mb-3">
              <v-card-title
                :style="`background: ${$vuetify.theme.currentTheme.primary}; color: ${$vuetify.theme.currentTheme.secondary};`"
              >
                <v-icon
                  large
                  class="mr-1"
                  :color="$vuetify.theme.currentTheme.secondary"
                  >{{ $vuetify.icons.values.order }}</v-icon
                >
                <span class="text-uppercase">orders</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <v-select
                      label="Status"
                      :color="$vuetify.theme.currentTheme.primary"
                      :item-color="$vuetify.theme.currentTheme.primary"
                      multiple
                      :items="selectedStatuses"
                      :hint="`${selectedStatuses.length} status${
                        selectedStatuses.length > 1 ||
                        selectedStatuses.length === 0
                          ? 'es'
                          : ''
                      } available`"
                      persistent-hint
                      v-model="payload.export.statuses"
                      @change="selectOrders"
                    >
                      <template v-slot:item="{ item }">
                        <v-badge
                          inline
                          dot
                          class="mr-1"
                          :color="item.color"
                        ></v-badge>
                        <span>{{ item.text }}</span>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <template class="mr-1" v-if="index === 0">
                          <v-badge
                            inline
                            dot
                            class="mr-1"
                            :color="item.color"
                          ></v-badge>
                          <span class="mr-1">{{ item.text }}</span>
                        </template>
                        <template v-if="index === 1">
                          <span class="grey--text text-caption">
                            (+{{ payload.export.statuses.length - 1 }} others)
                          </span>
                        </template>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="6" sm="12">
                    <v-text-field
                      label="Search"
                      rounded
                      :color="$vuetify.theme.currentTheme.primary"
                      background-color="optional"
                      prepend-inner-icon="mdi-magnify"
                      clearable
                      v-model.trim="payload.search.export"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div class="d-flex align-center justify-space-between">
                      <span class="text-caption text--secondary">
                        {{ payload.export.orders.length }} of
                        {{ fullOrders.length }} orders selected
                      </span>
                      <div>
                        <v-btn
                          small
                          text
                          :color="$vuetify.theme.currentTheme.primary"
                          @click="selectAllOrders"
                          :disabled="
                            payload.export.orders.length === fullOrders.length
                          "
                        >
                          <v-icon small class="mr-1"
                            >mdi-checkbox-multiple-marked</v-icon
                          >
                          Select All
                        </v-btn>
                        <v-btn
                          small
                          text
                          :color="$vuetify.theme.currentTheme.primary"
                          @click="selectOrders"
                          :disabled="payload.export.orders.length === 0"
                        >
                          <v-icon small class="mr-1"
                            >mdi-checkbox-blank-outline</v-icon
                          >
                          Clear All
                        </v-btn>
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-data-table
                  :headers="exportHeaders"
                  :items="fullOrders"
                  no-data-text="No Orders"
                  no-results-text="Order not found"
                  item-key="id"
                  sort-by="created"
                  sort-desc
                  show-select
                  :items-per-page="50"
                  :search="payload.search.export"
                  v-model="payload.export.orders"
                >
                  <template v-slot:item.number="{ index }">
                    <span>{{ index + 1 }}</span>
                  </template>
                  <template v-slot:item.created="{ item }">
                    <span>{{
                      item.created | moment("MM/DD/YYYY @ hh:mm A")
                    }}</span>
                  </template>
                  <template v-slot:item.shipDate="{ item }">
                    <template v-if="item.shipDate">
                      <span>{{ item.shipDate | moment("MM/DD/YYYY") }}</span>
                    </template>
                    <template v-else>
                      <span class="text--disabled">-</span>
                    </template>
                  </template>
                  <template v-slot:item.sample="{ item }">
                    <template v-if="item.sample">
                      <v-icon :color="$vuetify.theme.currentTheme.review"
                        >mdi-alpha-s-circle</v-icon
                      >
                    </template>
                    <template v-else>
                      <span class="text--disabled">-</span>
                    </template>
                  </template>
                  <template v-slot:item.units="{ item }">
                    <span>{{ parseInt(item.units) | addComma }}</span>
                  </template>
                  <template v-slot:item.balance="{ item }">
                    <span>{{ item.fullBalance?.due || item.balance | currency }}</span>
                  </template>
                  <template v-slot:item.total="{ item }">
                    <span>{{ item.fullBalance?.total || item.total | currency }}</span>
                  </template>
                  <template v-slot:item.internal="{ item }">
                    <span class="text-uppercase">{{ item.internal }}</span>
                  </template>
                  <template v-slot:item.external="{ item }">
                    <span class="text-uppercase">{{ item.external || "-" }}</span>
                  </template>
                  <template v-slot:item.statusText="{ item }">
                    <span
                      class="font-weight-bold"
                      :style="`color: ${item.statusColor};`"
                      >{{ item.statusText }}</span
                    >
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-btn
              small
              rounded
              :style="`background: ${$vuetify.theme.currentTheme.primary}; color: ${$vuetify.theme.currentTheme.secondary};`"
              @click="dialog.export = false"
            >
              <v-icon>{{ $vuetify.icons.values.back }}</v-icon>
              <span>back</span>
            </v-btn>
            <v-spacer />
            <v-btn
              small
              rounded
              :style="`background: ${$vuetify.theme.currentTheme.review}; color: ${$vuetify.theme.currentTheme.secondary};`"
              :loading="exportLoading"
              @click="traverse('export-orders')"
              :disabled="
                payload.export?.orders?.length === 0 ||
                (!payload.exportOptions.includeLineItems &&
                  !payload.exportOptions.includeOrders)
              "
            >
              <span class="mr-1">export</span>
              <v-icon>{{ $vuetify.icons.values.file }}</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        persistent
        scrollable
        transition="scale-transition"
        v-model="expanded"
      >
        <v-card class="rounded-lg">
          <v-card-title class="justify-center">
            <div class="d-flex align-center justify-start" style="gap: 8px">
              <v-icon>mdi-clipboard-list</v-icon>
              <div
                v-if="title"
                class="text-body-1 font-weight-black primary--text d-flex grow"
              >
                {{ title }}
              </div>
            </div>
          </v-card-title>
          <v-card-text v-if="expanded" class="pb-3">
            <v-data-table
              :headers="orderHeaders"
              :items="orders"
              :dense="dense"
              :loading="parentLoading || loading"
              :items-per-page.sync="itemsPerPage"
              :search="effectiveSearch"
              :custom-filter="customSearch"
              :custom-sort="customSort"
              :key="searchTrigger"
              no-results-text="No results found"
              loading-text="Loading..."
              sort-by="date"
              sort-desc
              mobile-breakpoint="0"
              :page.sync="currentPage"
              fixed-header
              height="100%"
              class="d-flex flex-grow-1 flex-column"
              style="overflow: auto; max-height: 50vh"
              hide-default-footer
            >
              <template v-slot:item.number="{ item, index }">
                <span class="text-caption text-lg-body-2">
                  {{
                    ((currentPage - 1) * itemsPerPage + index + 1) | addComma
                  }}
                </span>
              </template>
              <template v-slot:item.created="{ item }">
                <div class="d-flex flex-column">
                  <div
                    class="d-flex justify-start align-center text-truncate"
                    style="gap: 6px; width: 100%; max-width: 100%"
                  >
                    <v-icon xSmall>mdi-calendar</v-icon>
                    <span class="text-caption text-lg-body-2">{{
                      formatDate(item)
                    }}</span>
                  </div>
                  <div
                    class="d-flex justify-start align-center text-truncate"
                    style="gap: 6px; width: 100%; max-width: 100%"
                  >
                    <v-icon xSmall>mdi-account</v-icon>
                    <span
                      class="text-caption text-capitalize text--secondary"
                      :style="{
                        fontSize: $vuetify.breakpoint.smAndDown
                          ? '10px !important'
                          : '',
                      }"
                      >{{ item.createdBy }}</span
                    >
                  </div>
                </div>
              </template>
              <template v-slot:item.shipDate="{ item }">
                <span v-if="item.shipDate">
                  {{ item.shipDate | moment("MM/DD/YYYY") }}
                </span>
                <span v-else>-</span>
              </template>
              <template v-slot:item.paymentDueDate="{ item }">
                <span v-if="item.shipDate">
                  {{ item.paymentDueDate | moment("MM/DD/YYYY") }}
                </span>
                <span v-else>-</span>
              </template>
              <template v-slot:item.daysPastDue="{ item }">
                <span
                  v-if="item.shipDate && item.status.value === 'shipped'"
                  :class="
                    item.daysPastDue > 0
                      ? 'error--text font-weight-bold'
                      : 'text--secondary font-weight-medium'
                  "
                >
                  {{ Math.abs(item.daysPastDue) | addComma }}
                  {{ Math.abs(item.daysPastDue) === 1 ? "day" : "days" }}
                  {{ item.daysPastDue > 0 ? "past" : "until" }} due
                </span>
                <span v-else>-</span>
              </template>
              <template v-slot:item.sampleOrder="{ item }">
                <template v-if="item.sample">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon 
                        :color="$vuetify.theme.currentTheme.review" 
                        v-bind="attrs" 
                        v-on="on"
                      >mdi-alpha-s-circle
                      </v-icon>
                    </template>
                    <span>{{
                      item.samplePurpose === 'buyerSamples' ? 'Buyer Sample' :
                      item.samplePurpose === 'eventSamples' ? 'Event Sample' :
                      item.samplePurpose === 'staffSamples' ? 'Staff Sample' :
                      'Sample Order'
                    }}</span>
                  </v-tooltip>
                </template>
                <template v-else>
                  <span class="text--disabled">-</span>
                </template>
              </template>
              <!-- <template v-slot:item.sampleOrder="{ item }">
                <template v-if="item.sample">
                  <v-icon :color="$vuetify.theme.currentTheme.review"
                    >mdi-alpha-s-circle</v-icon
                  >
                </template>
                <template v-else>
                  <span class="text--disabled">-</span>
                </template>
              </template> -->
              <template v-slot:item.balance="{ item }">
                <span>{{ item.balance | currency }}</span>
              </template>
              <template v-slot:item.amount="{ item }">
                <span>{{ item.amount | currency }}</span>
              </template>
              <template v-slot:item.internal="{ item }">
                <div class="d-flex flex-column">
                  <router-link
                    v-if="item.internal"
                    :to="{ name: 'salesOrder-view', params: { id: item.id } }"
                    target="_blank"
                    class="review--text"
                  >
                    <span
                      class="text-uppercase text-caption text-lg-body-2 text-no-wrap"
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'font-weight-bold'
                          : 'font-weight-medium'
                      "
                      >{{ item.internal.toUpperCase() }}</span
                    >
                  </router-link>
                  <span
                    v-else
                    class="text-caption text-lg-body-2 text--disabled"
                    >-</span
                  >
                </div>
              </template>
              <template v-slot:item.external="{ item }">
                <div class="d-flex flex-column">
                  <span
                    v-if="item.external"
                    class="text-uppercase text-caption text-lg-body-2 text-no-wrap text--secondary"
                    :style="{
                      fontSize: $vuetify.breakpoint.smAndDown
                        ? '10px !important'
                        : '',
                    }"
                    >{{ item.external.toUpperCase() }}
                  </span>
                  <span
                    v-else
                    class="text-caption text-lg-body-2 text--disabled"
                    >-</span
                  >
                </div>
              </template>
              <template v-slot:item.status="{ item }">
                <span
                  class="font-weight-bold text-center text-caption text-lg-body-2 text-no-wrap rounded-pill"
                  :style="{
                    background: `${
                      ['error', 'products'].includes(item.statusColor)
                        ? $vuetify.theme.currentTheme[item.statusColor]
                        : item.statusColor
                    }33`,
                    color: `${
                      ['error', 'products'].includes(item.statusColor)
                        ? $vuetify.theme.currentTheme[item.statusColor]
                        : item.statusColor
                    }`,
                    padding: $vuetify.breakpoint.smAndDown
                      ? '3px 10px'
                      : '5px 12px',
                  }"
                  style="min-width: 67px"
                >
                  {{ item.status.text }}
                </span>
              </template>
              <template v-slot:item.total="{ item }">
                <span class="text-caption text-lg-body-2">{{
                  item.total | currency
                }}</span>
              </template>
              <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-center" style="gap: 8px">
                  <DelayedTooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        outlined
                        text
                        icon
                        v-bind="attrs"
                        :loading="item.loadingPreview"
                        v-on="on"
                        color="review"
                        class="rounded"
                        @click.stop
                        style="min-width: 21px"
                      >
                        <v-icon small>mdi-text-box-search</v-icon>
                      </v-btn>
                    </template>
                    Preview
                  </DelayedTooltip>
                  <router-link
                    v-if="item.status.value !== 'draftOrder'"
                    @click.stop
                    :to="{ name: 'salesOrder-view', params: { id: item.id } }"
                  >
                    <DelayedTooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          text
                          icon
                          outlined
                          v-bind="attrs"
                          v-on="on"
                          color="review"
                          class="rounded"
                          style="min-width: 21px"
                        >
                          <v-icon small>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      View
                    </DelayedTooltip>
                  </router-link>
                </div>
              </template>
              <template v-slot:footer="{ props, on, headers, widths }">
                <v-divider class="d-block"></v-divider>
                <div class="my-3 d-flex justify-space-between align-center">
                  <div
                    v-if="deviceSize.tablet"
                    class="d-flex justify-start align-center ml-2 flex-wrap"
                    style="column-gap: 12px"
                  >
                    <span
                      class="rounded-pill review--text text-caption d-flex align-center justify-center text-lg-body-2 font-weight-bold"
                      style="height: 28px; gap: 6px"
                    >
                      <v-icon small color="review">
                        mdi-table-row-height
                      </v-icon>
                      <span>Rows:</span>
                    </span>
                    <v-chip-group
                      v-model="itemsPerPage"
                      active-class="review--text font-weight-black"
                      class="text-caption font-weight-bold"
                      mandatory
                    >
                      <v-chip
                        v-for="size in [5, 10, 15, 'All']"
                        small
                        :key="size"
                        :outlined="
                          itemsPerPage === size ||
                          (itemsPerPage === -1 && size === 'All')
                        "
                        :style="filterBackgroundColor"
                        :value="typeof size === 'number' ? size : -1"
                      >
                        {{ size }}
                      </v-chip>
                    </v-chip-group>
                  </div>
                  <v-menu
                    v-else
                    offset-y
                    :nudge-bottom="8"
                    content-class="rounded-lg"
                  >
                    <template v-slot:activator="{ on, attrs, value }">
                      <v-chip
                        :style="filterBackgroundColor"
                        v-bind="attrs"
                        v-on="on"
                        close-icon="mdi-trash-can"
                        text-color="review"
                        class="rounded-pill text-caption text-lg-body-2 font-weight-bold"
                        style="padding-right: 10px"
                        @click:close="currentTab = null"
                      >
                        <div
                          class="d-flex align-center justify-center"
                          style="height: 28px; gap: 6px"
                        >
                          <v-icon small color="review">
                            mdi-table-row-height
                          </v-icon>
                          <div class="d-flex align-center justify-center">
                            <span class="mr-1"
                              >Rows:
                              <span class="font-weight-black">{{
                                itemsPerPage === -1 ? "All" : itemsPerPage
                              }}</span></span
                            >
                            <v-icon
                              size="20"
                              color="review"
                              :class="{ rotate: value }"
                            >
                              mdi-menu-down
                            </v-icon>
                          </div>
                        </div>
                      </v-chip>
                    </template>
                    <v-list dense content-class="rounded-lg">
                      <v-list-item
                        v-for="(item, index) in [5, 10, 15, 'All']"
                        :key="index"
                        @click="itemsPerPage = item === 'All' ? -1 : item"
                        :dense="$vuetify.breakpoint.smAndDown"
                        :style="{
                          minHeight: $vuetify.breakpoint.smAndDown
                            ? '35px'
                            : '40px',
                        }"
                      >
                        <v-list-item-title
                          class="d-flex align-center"
                          :style="{
                            minHeight: $vuetify.breakpoint.smAndDown
                              ? '35px'
                              : '40px',
                          }"
                          >{{ item }}</v-list-item-title
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <div class="d-flex align-center" style="gap: 20px">
                    <span class="text-caption font-weight-medium text-end">{{
                      `${$options.filters.addComma(
                        props.pagination.page * itemsPerPage - itemsPerPage + 1
                      )}-${$options.filters.addComma(
                        itemsPerPage === -1
                          ? props.pagination.itemsLength
                          : Math.min(
                              props.pagination.itemsLength,
                              props.pagination.page * itemsPerPage
                            )
                      )} of ${$options.filters.addComma(
                        props.pagination.itemsLength
                      )}`
                    }}</span>
                    <div class="d-flex align-center" style="gap: 8px">
                      <v-btn
                        class="text-caption font-weight-bold"
                        :min-height="
                          $vuetify.breakpoint.smAndDown ? '30px' : '40px'
                        "
                        outlined
                        small
                        depressed
                        text
                        color="review"
                        style="text-transform: none !important"
                        @click="props.options.page--"
                        :disabled="props.options.page - 1 === 0"
                      >
                        <v-icon>mdi-chevron-left</v-icon>
                      </v-btn>
                      <v-btn
                        class="text-caption font-weight-bold"
                        :min-height="
                          $vuetify.breakpoint.smAndDown ? '30px' : '40px'
                        "
                        outlined
                        small
                        depressed
                        text
                        color="review"
                        style="text-transform: none !important"
                        @click="props.options.page++"
                        :disabled="
                          props.options.page + 1 > props.pagination.pageCount
                        "
                      >
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:item.lastPaymentDate="{ item }">
                <span
                  v-if="
                    !item.lastPaymentDate &&
                    !item.loadingLastPayment &&
                    !item.loaded
                  "
                  >{{ getLastPaymentDate(item) }}</span
                >
                <v-progress-circular
                  v-else-if="item.loadingLastPayment && !item.lastPaymentDate"
                  indeterminate
                  color="loading"
                  size="10"
                  width="2"
                />
                <div
                  v-else-if="item.lastPaymentDate"
                  class="d-flex flex-column"
                >
                  <span>
                    {{ item.lastPaymentDate | moment("MM/DD/YYYY") }}
                  </span>
                  <span
                    class="text-caption"
                    :class="
                      getDifference(item) > 0
                        ? 'error--text font-weight-bold'
                        : 'text--secondary font-weight-medium'
                    "
                  >
                    {{ Math.abs(getDifference(item)) }}
                    {{ Math.abs(getDifference(item)) === 1 ? "day" : "days" }}
                    {{ getDifference(item) > 0 ? "after" : "before" }}
                    due date
                  </span>
                </div>
                <span v-else>-</span>
              </template>
            </v-data-table>
            <v-divider class="d-block"></v-divider>
          </v-card-text>
          <v-card-actions>
            <v-btn
              small
              rounded
              text
              @click="expanded = false"
              color="review"
              class="text-caption font-weight-bold"
            >
              <v-icon small class="mr-2">mdi-arrow-left</v-icon>
              <span>back</span>
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-fade-transition>
</template>

<script>
// Libraries
import { mapGetters } from "vuex";
import * as exceljs from "exceljs";
import {
  // Firestore
  firestore,
  collection,
  getDocs,
  where,
  query,
  getDoc,
  doc,
  onSnapshot,
  // Functions
  functions,
  httpsCallable,
  // Remote Config
  remoteConfig,
  getValue,
} from "@/firebase/init";
// Components
import moment from "moment-timezone";

import SalesOrderViewerLabel from "@/components/misc/ui/SalesOrderViewerLabel.vue";
import StyledButton from "@/components/misc/ui/buttons/StyledButton.vue";

export default {
  name: "sales-order-table",
  props: {
    parentLoading: {
      default: false,
      type: Boolean,
      required: false,
    },
    dense: {
      default: false,
      type: Boolean,
      required: false,
    },
    headers: {
      default: () => [
        { text: "#", value: "number", align: "center", sortable: false },
        { text: "Order #", value: "orderNumber" },
        { text: "Date", value: "date" },
        { text: "Status", value: "status" },
        { text: "Balance", value: "balance" },
        { text: "Total", value: "total" },
        { text: "", value: "actions" },
      ],
      type: Array,
      required: false,
    },
    queryData: {
      type: Array,
      required: true,
    },
    title: {
      default: "Orders",
      type: String,
      required: false,
    },
    enableExport: {
      default: false,
      type: Boolean,
      required: false,
    },
    exportAccountName: {
      default: "",
      type: String,
      required: false,
    },
  },
  components: {
    SalesOrderViewerLabel,
    StyledButton,
  },
  data: () => ({
    loading: false,
    exportLoading: false,
    orders: [],
    snapshots: [],
    currentTab: "",
    search: "",
    showFilters: false,
    searchTrigger: 0,
    currentPage: 1,
    itemsPerPage: 5,
    mobileSearch: false,
    showFilters: false,
    expanded: false,
    dialog: {
      export: false,
    },
    payload: {
      export: null,
      exportOptions: {
        includeLineItems: true,
        includeOrders: false,
      },
      search: {
        export: "",
      },
    },
    response: {
      headers: {
        salesOrders: [
          { text: "#", value: "number", align: "center", sortable: false },
          { text: "Created", value: "created" },
          { text: "Ship Date", value: "shipDate" },
          { text: "Sample", value: "sample" },
          { text: "Internal", value: "internal" },
          { text: "External", value: "external" },
          { text: "Units", value: "units" },
          { text: "Balance", value: "balance" },
          { text: "Total", value: "total" },
          { text: "Status", value: "statusText" },
        ],
      },
    },
  }),
  watch: {
    queryData: {
      handler: "setup",
      deep: true,
    },
    currentTab() {
      this.searchTrigger++; // Increment trigger to force filter refresh
    },
  },
  async created() {
    await this.setup();
  },
  methods: {
    /* API Calls */
    // GET
    async getOrders() {
      this.loading = true;
      this.orders = [];
      if (!this.queryData?.length) {
        this.loading = false;
        return;
      }

      for (const queryData of this.queryData) {
        let whereData = queryData.where.map((item) => {
          return where(item.field, item.operator, item.value);
        });
        let q = query(
          collection(firestore, queryData.collection),
          ...whereData
        );
        let response = await getDocs(q);
        if (!response.empty) {
          this.orders = this.orders
            .concat(
              response.docs.map((order) => {
                if (order.data().status === "rejected") {
                  order.data().status = "cancelled";
                }

                let status = this.getOrderStatus.find(
                  (status) => status.value === order.data().status
                );

                if (order.data().status === "draftOrder") {
                  status = {
                    color: this.$vuetify.theme.currentTheme.ledger,
                    text: "Draft",
                    value: "draftOrder",
                  };
                }

                const shipDate = order.data().shipDate
                  ? moment(order.data().shipDate.seconds * 1000).toDate()
                  : null;
                const paymentTerm = order.data().paymentTerm
                  ? this.getPaymentTerms.find(
                      (option) => option.value === order.data().paymentTerm
                    )
                  : null;
                let paymentDueDate = null,
                  daysPastDue = null;
                if (shipDate && paymentTerm) {
                  paymentDueDate = moment(shipDate).add(
                    paymentTerm.due,
                    "days"
                  );
                  daysPastDue = moment().diff(moment(paymentDueDate), "days");
                  daysPastDue = daysPastDue < 0 ? daysPastDue - 1 : daysPastDue;
                }

                if (!status?.color) {
                  console.log("Status not found", order.data().status);
                }

                return {
                  id: order.id,
                  ...order.data(),
                  created: order.data().created
                    ? moment(order.data().created.seconds * 1000).toDate()
                    : null,
                  updated: order.data().updated
                    ? moment(order.data().updated.seconds * 1000).toDate()
                    : null,
                  external: order.data().orderNumber.external,
                  internal: String(order.data().orderNumber.internal),
                  orderNumber: order.data().orderNumber,
                  paid: order.data().flags.paid,
                  createdBy: `${order.data().createdBy.name.first} ${
                    order.data().createdBy.name.last
                  }`,
                  shipDate,
                  status,
                  statusColor: status.color,
                  statusAlternateColor: `${status.color}33`,
                  paymentDueDate,
                  daysPastDue,
                  sampleOrder: order.data().flags.sample,
                  samplePurpose: order.data().samplePurpose || null,
                  paymentTerm: paymentTerm?.text || "",
                  amount: Number(order.data().balance.total),
                  balance: Number(order.data().balance.due),
                  fullBalance: {
                    due: Number(order.data().balance.due),
                    excise: Number(order.data().balance.excise),
                    shipping: Number(order.data().balance.shipping),
                    total: Number(order.data().balance.total),
                  },
                  lineItems: order.data().lineItems.map((item) => {
                    return {
                      ...item,
                      promo:
                        item.promo ??
                        (item.amount <= 0.1 && !order.data().flags.sample),
                    };
                  }),
                  units: order.data().units,
                  sample: order.data().flags.sample,
                  total: Number(order.data().balance.total),
                  account: order.data().account.name,
                  accountID: order.data().account.id,
                  accountObj: order.data().account,
                  locationObj: order.data().location || null,
                  address: order.data().location.shipping,
                  internalNotes: order.data().internalNotes || "",
                  paymentTermDef: paymentTerm,
                  loadingPreview: false,
                  loadingLastPayment: false,
                  lastPayment: null,
                };
              })
            )
            .sort((a, b) => (a.created > b.created ? -1 : 1));
        }
      }

      this.loading = false;
    },
    async getLastPaymentDate(item) {
      item.loadingLastPayment = true;
      let paymentsDocs = query(
        collection(firestore, "salesOrders_payments"),
        where("relatedID", "==", item.id),
        where("flags.reversed", "==", false)
        // orderBy("created", "desc")
      );
      let response = await getDocs(paymentsDocs);

      let sortedPayments = response.docs.sort((a, b) =>
        a.data().paymentDate.seconds > b.data().paymentDate.seconds ? -1 : 1
      );

      if (sortedPayments.length > 0) {
        let lastPayment = sortedPayments[0].data();
        item.lastPaymentDate = moment(
          lastPayment.paymentDate.seconds * 1000
        ).format("MM/DD/YYYY");
        item.loadingLastPayment = false;
        return moment(lastPayment.paymentDate.seconds * 1000).format(
          "MM/DD/YYYY"
        );
      }
      item.loadingLastPayment = false;
      item.lastPaymentDate = null;
      item.loaded = true;
      return null;
    },
    getDifference(item) {
      if (!item.lastPaymentDate) return null;
      let paymentDate = moment(item.lastPaymentDate);
      let dueDate = moment(item.paymentDueDate);
      let difference = moment(paymentDate).diff(moment(dueDate), "days");
      if (difference >= 0) {
        return difference + 1;
      }
      return difference;
    },
    // POST
    /* Main */
    async setup() {
      await this.getOrders();
    },
    customSearch(value, search, item) {
      let tempItem = JSON.parse(JSON.stringify(item));
      let statusMatch = this.currentTab
        ? item.status.value === this.currentTab
        : true;
      if (!this.search?.length) return statusMatch;
      tempItem.created = moment(tempItem.created).format("MM/DD/YYYY");
      tempItem.shipDate = moment(tempItem.shipDate).format("MM/DD/YYYY");
      tempItem.status = item.status.text;
      let itemMatch = Object.values(tempItem).some(
        (v) => v && String(v).toLowerCase().includes(this.search.toLowerCase())
      );
      if (!this.currentTab) return itemMatch;
      return statusMatch && itemMatch;
    },
    customSort(items, sortBy, sortDesc, ...others) {
      if (!sortBy.length) return items;
      let sortByField = sortBy[0];
      let sortDescField = sortDesc[0];
      return items.sort((a, b) => {
        let tempItem1 = JSON.parse(JSON.stringify(a));
        let tempItem2 = JSON.parse(JSON.stringify(b));
        if (sortByField !== "date") {
          tempItem1 = tempItem1[sortByField];
          tempItem2 = tempItem2[sortByField];
        } else {
          tempItem1 = tempItem1.created;
          tempItem2 = tempItem2.created;
        }
        if (sortDesc) {
          [tempItem1, tempItem2] = [tempItem2, tempItem1];
        }
        return tempItem1 > tempItem2 === sortDescField ? 1 : -1;
      });
    },
    /* Misc */
    formatDate(item) {
      const date = item.created;

      const format = "dateFormat";

      return this.$options.filters[format](date);
    },
    handleSearchClick() {
      this.mobileSearch = true;
      this.$nextTick(() => {
        document.getElementById("search").focus();
      });
    },
    handleSearchOpen() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.showFilters = false;
      }
    },
    handleSearchClose() {
      this.mobileSearch = false;
    },
    handleExpandClick() {
      this.expanded = true;
    },
    traverse(action) {
      switch (action) {
        case "export":
          this.payload.export = {
            statuses: ["shipped", "complete"],
            orders: [],
          };
          this.selectOrders();
          this.dialog.export = true;
          break;
        case "export-orders":
          this.export();
          break;
      }
    },
    selectOrders() {
      this.payload.export.orders = [];
    },
    selectAllOrders() {
      this.payload.export.orders = [...this.fullOrders];
    },
    getOrderCreditAssignee(account) {
      if (account?.staff?.executive?.id && account.staff.executive.id.length > 0) {
        return {
          id: account.staff.executive.id,
          name: account.staff.executive.name,
          email: account.staff.executive.email,
          role: "executive",
        };
      }
      if (account?.staff?.manager?.id && account.staff.manager.id.length > 0) {
        return {
          id: account.staff.manager.id,
          name: account.staff.manager.name,
          email: account.staff.manager.email,
          role: "manager",
        };
      }
      return null;
    },
    getShippingAddress(order) {
      const shipping = order?.locationObj?.shipping;
      if (!shipping) return "-";
      const streetNumber = shipping?.street?.number || "";
      const streetName = shipping?.street?.name || "";
      const city = shipping?.city || "";
      const state = shipping?.state?.abbreviation
        ? String(shipping.state.abbreviation).toUpperCase()
        : "";
      const zip = shipping?.zipCode || "";
      const address = `${streetNumber} ${streetName}, ${city}, ${state} ${zip}`.trim();
      return address.replace(/\s+/g, " ").replace(/,\s*,/g, ",") || "-";
    },
    getDeliveryOptionText(order) {
      if (!order?.deliveryOption) return "-";
      const def = this.getDeliveryTypes?.find(
        (d) => d.value === order.deliveryOption
      );
      return def?.text || order.deliveryOption || "-";
    },
    normalizeText(value, fallback = "-") {
      if (value === null || value === undefined) return fallback;
      if (typeof value === "string") return value.length ? value : fallback;
      if (typeof value === "number" || typeof value === "boolean") {
        return String(value);
      }
      if (Array.isArray(value)) {
        const parts = value
          .map((v) => this.normalizeText(v, ""))
          .map((v) => String(v || "").trim())
          .filter(Boolean);
        return parts.length ? parts.join(", ") : fallback;
      }
      if (typeof value === "object") {
        if (typeof value.text === "string" && value.text.length) return value.text;
        if (typeof value.name === "string" && value.name.length) return value.name;
        if (value.name && typeof value.name === "object") {
          const first = value.name.first || "";
          const last = value.name.last || "";
          const full = `${first} ${last}`.trim();
          if (full.length) return full;
        }
        if (typeof value.abbreviation === "string" && value.abbreviation.length) {
          return value.abbreviation;
        }
        return fallback;
      }
      return fallback;
    },
    cap(value, fallback = "-") {
      const text = this.normalizeText(value, fallback);
      return this.$options.filters.capitalize(text);
    },
    toNumber(value) {
      if (value === null || value === undefined) return null;
      if (typeof value === "number") return Number.isFinite(value) ? value : null;
      if (typeof value === "string") {
        const n = parseFloat(value);
        return Number.isFinite(n) ? n : null;
      }
      if (typeof value === "boolean") return value ? 1 : 0;
      return null;
    },
    extractNumber(value, depth = 0) {
      if (depth > 4) return null;
      const direct = this.toNumber(value);
      if (direct !== null) return direct;
      if (!value || typeof value !== "object") return null;
      // Common shapes we see in older order docs
      const candidates = [
        value.amount,
        value.value,
        value.price,
        value.sale,
        value.normal,
      ];
      for (const c of candidates) {
        const n = this.extractNumber(c, depth + 1);
        if (n !== null) return n;
      }
      return null;
    },
    getLineItemUnitPrice(lineItem) {
      // Match `SalesOrders_Report.vue`: item.amount is the UNIT price.
      const amountAsUnitPrice = this.extractNumber(lineItem?.amount);
      if (amountAsUnitPrice !== null) return amountAsUnitPrice;

      // Fallback for any legacy/edge cases
      const price = lineItem?.price;
      const direct = this.extractNumber(price);
      if (direct !== null) return direct;

      if (price && typeof price === "object") {
        const preferred = lineItem?.promo ? price.normal : price.sale;
        const preferredNum = this.extractNumber(preferred);
        if (preferredNum !== null) return preferredNum;
        const fallbackNum =
          this.extractNumber(price.sale) ?? this.extractNumber(price.normal);
        if (fallbackNum !== null) return fallbackNum;
      }

      return 0;
    },
    sanitizeFileComponent(value) {
      return String(value || "")
        .replace(/[\/\\?%*:|"<>]/g, "-")
        .replace(/\s+/g, " ")
        .trim();
    },
    async export() {
      this.exportLoading = true;
      const wb = new exceljs.Workbook();

      const selectedOrders = this.payload.export?.orders || [];
      const createdDates = selectedOrders
        .map((o) => o.created)
        .filter(Boolean)
        .sort((a, b) => (a > b ? 1 : -1));
      const start = createdDates.length
        ? moment(createdDates[0]).format("MM/DD/YYYY")
        : moment().format("MM/DD/YYYY");
      const end = createdDates.length > 1
        ? moment(createdDates[createdDates.length - 1]).format("MM/DD/YYYY")
        : start;
      const dateRange = createdDates.length > 1 ? `${start}_${end}` : start;

      // Create Line Items worksheet if selected
      if (this.payload.exportOptions.includeLineItems) {
        const lineItemsWorksheet = wb.addWorksheet("Line Items");
        lineItemsWorksheet.columns = [
          { header: "Created", key: "created" },
          { header: "Created By", key: "createdBy" },
          { header: "Managed By", key: "managedBy" },
          { header: "Account", key: "account" },
          { header: "Account License #", key: "licenseNumber" },
          { header: "Shipping Address", key: "shippingAddress" },
          { header: "Ship Date", key: "shipDate" },
          { header: "Payment Term", key: "paymentTerm" },
          { header: "Product", key: "product" },
          { header: "SKU", key: "sku" },
          { header: "Product Category", key: "productCategory" },
          { header: "Total QTY", key: "qty" },
          { header: "Unit Price", key: "unitPrice" },
          { header: "Total Sales", key: "totalSales" },
          { header: "Sample?", key: "sample" },
          { header: "Status", key: "status" },
          { header: "Internal Order #", key: "internalOrder" },
          { header: "External Order #", key: "externalOrder" },
        ];

        selectedOrders.forEach((order) => {
          const creditAssignee = this.getOrderCreditAssignee(order.accountObj);
          const managedBy = creditAssignee?.name || "-";
          const accountName = this.exportAccountName || order.account || "-";
          const licenseNumber = order.accountObj?.license
            ? String(order.accountObj.license).toUpperCase()
            : "-";
          const shippingAddress = this.getShippingAddress(order);
          const created = order.created
            ? moment(order.created).format("MM/DD/YYYY")
            : "-";
          const shipDate = order.shipDate
            ? moment(order.shipDate).format("MM/DD/YYYY")
            : "-";
          const paymentTerm = order.paymentTermDef?.text || order.paymentTerm || "-";
          const status = order.statusText || order.status?.text || "-";
          const internalOrder = String(order.internal || order.orderNumber?.internal || "")
            .toUpperCase()
            .trim();
          const externalOrder = order.external || order.orderNumber?.external || "-";

          (order.lineItems || []).forEach((lineItem) => {
            const unitPrice = this.getLineItemUnitPrice(lineItem);
            const qty = this.extractNumber(lineItem?.qty) || 0;
            const totalSales = (this.extractNumber(unitPrice) || 0) * qty;
            lineItemsWorksheet.addRow([
              created,
              this.cap(order.createdBy, "-"),
              this.cap(managedBy, "-"),
              this.cap(accountName, "-"),
              licenseNumber,
              this.cap(shippingAddress, "-"),
              shipDate,
              paymentTerm,
              this.cap(lineItem.name, "-"),
              String(lineItem.sku || "-").toUpperCase(),
              this.cap(lineItem.productCategory, "-"),
              parseInt(qty || 0),
              parseFloat(unitPrice || 0),
              parseFloat(totalSales || 0),
              lineItem?.flags?.sample || order.sample ? "SAMPLE" : "-",
              this.cap(status, "-"),
              internalOrder || "-",
              externalOrder || "-",
            ]);
          });
        });
      }

      // Create Orders Summary worksheet if selected
      if (this.payload.exportOptions.includeOrders) {
        const ordersWorksheet = wb.addWorksheet("Orders Summary");
        ordersWorksheet.columns = [
          { header: "Created", key: "created" },
          { header: "Created By", key: "createdBy" },
          { header: "Managed By", key: "managedBy" },
          { header: "Account", key: "account" },
          { header: "License Number", key: "licenseNumber" },
          { header: "Ship Date", key: "shipDate" },
          { header: "Delivery Option", key: "deliveryOption" },
          { header: "Delivered By", key: "deliveredBy" },
          { header: "Fulfillment Location", key: "fulfillmentLocation" },
          { header: "Sample Order?", key: "sampleOrder" },
          { header: "Payment Term", key: "paymentTerm" },
          { header: "Internal Order #", key: "internalOrder" },
          { header: "External Order #", key: "externalOrder" },
          { header: "Units", key: "units" },
          { header: "Brand", key: "brand" },
          { header: "Balance", key: "balance" },
          { header: "Subtotal", key: "subtotal" },
          { header: "Shipping Fee", key: "shippingFee" },
          { header: "Total", key: "total" },
          { header: "Status", key: "status" },
          { header: "Notes", key: "notes" },
        ];

        selectedOrders.forEach((order) => {
          const creditAssignee = this.getOrderCreditAssignee(order.accountObj);
          const managedBy = creditAssignee?.name || "-";
          const accountName = this.exportAccountName || order.account || "-";
          const licenseNumber = order.accountObj?.license
            ? String(order.accountObj.license).toUpperCase()
            : "-";
          const shipDate = order.shipDate
            ? moment(order.shipDate).format("YYYY-MM-DD")
            : "-";
          const deliveryOption = this.getDeliveryOptionText(order);
          const deliveredBy = order.deliveredBy || "-";
          const fulfillmentLocation = order.fulfillmentLocation?.name
            ? this.$options.filters.capitalize(order.fulfillmentLocation.name)
            : "-";
          const sampleOrder = order.sample ? "SAMPLE" : "REGULAR";
          const paymentTerm = order.paymentTermDef?.text || order.paymentTerm || "-";
          const internalOrder = String(order.internal || order.orderNumber?.internal || "")
            .toUpperCase()
            .trim();
          const externalOrder = order.external || order.orderNumber?.external || "-";
          const units = parseInt(order.units || 0);
          const brand =
            order.lineItems && order.lineItems.length > 0
              ? order.lineItems[0].brand || "-"
              : "-";
          const balanceDue =
            typeof order.fullBalance?.due === "number"
              ? order.fullBalance.due
              : Number(order.balance || 0);
          const total =
            typeof order.fullBalance?.total === "number"
              ? order.fullBalance.total
              : Number(order.total || 0);
          const shippingFee =
            typeof order.fullBalance?.shipping === "number"
              ? order.fullBalance.shipping
              : 0;
          const subtotal = total - shippingFee;
          const status = order.statusText || order.status?.text || "-";
          const notes = order.notes || order.internalNotes || "-";

          ordersWorksheet.addRow([
            order.created ? moment(order.created).format("MM/DD/YYYY @ hh:mm A") : "-",
            this.cap(order.createdBy, "-"),
            this.cap(managedBy, "-"),
            this.cap(accountName, "-"),
            licenseNumber,
            shipDate,
            deliveryOption,
            deliveredBy ? this.cap(deliveredBy, "-") : "-",
            fulfillmentLocation,
            sampleOrder,
            paymentTerm,
            internalOrder || "-",
            externalOrder || "-",
            units,
            this.cap(brand, "-"),
            parseFloat(balanceDue || 0),
            parseFloat(subtotal || 0),
            parseFloat(shippingFee || 0),
            parseFloat(total || 0),
            this.cap(status, "-"),
            notes,
          ]);
        });
      }

      await wb.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.setAttribute("style", "display: none");
        a.href = url;
        const accountPart = this.sanitizeFileComponent(
          this.exportAccountName || "ACCOUNT"
        );
        a.download = `${accountPart} Orders - ${dateRange}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      });

      this.exportLoading = false;
    },
  },
  computed: {
    ...mapGetters([
      "getAppName",
      "getUser",
      "getOrderStatus",
      "getPaymentTerms",
      "getDeliveryTypes",
    ]),
    effectiveSearch() {
      if (!this.currentTab) return this.search;
      return this.search + " | " + this.currentTab;
    },
    selectedStatus() {
      return this.getOrderStatus.find(
        (status) => status.value === this.currentTab
      );
    },
    filterBackgroundColor() {
      return this.$vuetify.theme.isDark
        ? "background-color: var(--v-background-lighten1)"
        : "background-color: var(--v-background-base)";
    },
    orderStatuses() {
      let statuses = JSON.parse(JSON.stringify(this.getOrderStatus));
      statuses = statuses.flatMap((status) => {
        switch (status.value) {
          case "cancelled":
            return {
              ...status,
              text: "Cancelled/Rejected",
              value: "cancelled",
            };
            break;
          case "rejected":
            return [];
          default:
            return status;
            break;
        }
      });
      let cancelled = statuses.shift();
      statuses.push(cancelled);
      let draft = {
        color: this.$vuetify.theme.currentTheme.ledger,
        text: "Draft",
        value: "draftOrder",
      };
      statuses.unshift(draft);
      return statuses;
    },
    orderHeaders() {
      return [
        {
          text: "#",
          value: "number",
          sortable: false,
          groupable: false,
        },
        {
          text: "Created",
          value: "created",
          sortable: true,
          groupable: false,
        },
        {
          text: "Status",
          value: "status",
          sortable: true,
          groupable: false,
        },
        {
          text: "Sample Order?",
          value: "sampleOrder",
          sortable: true,
          groupable: true,
        },
        {
          text: "Balance",
          value: "balance",
          sortable: true,
          groupable: false,
        },
        {
          text: "Total Sum",
          value: "amount",
          sortable: true,
          groupable: false,
        },
        {
          text: "Ship Date",
          value: "shipDate",
          sortable: true,
          groupable: false,
        },
        {
          text: "Payment Term",
          value: "paymentTerm",
          sortable: true,
          groupable: false,
        },
        {
          text: "Payment Due Date",
          value: "paymentDueDate",
          sortable: true,
          groupable: false,
        },
        {
          text: "Days Past/Until Due",
          value: "daysPastDue",
          sortable: true,
          groupable: false,
        },
        {
          text: "Last Payment Date",
          value: "lastPaymentDate",
          sortable: true,
          groupable: false,
        },
        {
          text: "Internal Order #",
          value: "internal",
          sortable: true,
          groupable: false,
        },
        {
          text: "External Order #",
          value: "external",
          sortable: true,
          groupable: false,
        },
        // {
        //   text: "Preview",
        //   value: "preview",
        //   sortable: false,
        //   groupable: false,
        // },
        // { text: "View", value: "view", sortable: false, groupable: false },
      ];
    },
    exportHeaders() {
      return this.response.headers.salesOrders;
    },
    fullOrders() {
      return (this.orders || []).map((order) => {
        return {
          ...order,
          statusText: order.status?.text || order.status || "-",
          internal: order.internal ? String(order.internal).toUpperCase() : "-",
          external: order.external ? String(order.external).toUpperCase() : "-",
        };
      });
    },
    selectedStatuses() {
      const orderStatusValues = new Set(
        (this.orders || [])
          .map((o) => o.status?.value)
          .filter((v) => !!v)
      );
      return this.orderStatuses.filter((option) =>
        orderStatusValues.size ? orderStatusValues.has(option.value) : true
      );
    },
  },
};
</script>

<style scoped>
.rotate {
  transform: rotate(180deg);
}
.softShadow {
  box-shadow: rgba(149, 157, 165, 0.4) 0px 8px 24px !important;
}

.overflow-auto {
  overflow-x: scroll !important;
  scroll-behavior: smooth !important; /* Enables inertia-like scrolling */
  -webkit-overflow-scrolling: touch !important; /* Enables smooth scrolling on iOS */
}
</style>
